export default __webpack_public_path__ + "static/media/UMCP.5022b9de.svg";